import type { ReactNode } from "react";
import { toast } from "sonner";

export const notifyInfo = (message: ReactNode) => toast.info(message);
export const notifySuccess = (message: ReactNode) => toast.success(message);
export const notifyWarning = (message: ReactNode) => toast.warning(message);
export const notifyError = (message: ReactNode) => toast.error(message);
